<div class="d-flex justify-content-between align-items-center pb-2 flex-wrap">
  <div class="row mt-3">
    <div class="col" style="min-width: 300px">
      <div>
        <span>{{ 'CASES.single.payments.balance_overview.filtered_balance.progress' | translate }}:</span>
        <span class="font-weight-bold">{{ +(filteredInstallmentsBalance.totalPaid) | number: '1.2-2' }}
          € / {{ +(filteredInstallmentsBalance.totalToPay) | number: '1.2-2' }} € </span>
      </div>
      <div>
        <span>{{ 'CASES.single.payments.balance_overview.filtered_balance.balance' | translate }}:</span>
        <span class="font-weight-bold">{{
            +(filteredInstallmentsBalance.totalToPay -
              filteredInstallmentsBalance.totalPaid) | number: '1.2-2'
          }} €</span>
      </div>
      <!--<div class="progress total-progress" style="max-width: 300px">-->
      <!--  <div class="progress-bar progress-bar-striped" role="progressbar"-->
      <!--       [style]="{width: getPercent(filteredInstallmentsBalance.totalPaid, filteredInstallmentsBalance.totalToPay) + '%'}"-->
      <!--       [attr.aria-valuenow]="getPercent(filteredInstallmentsBalance.totalPaid, filteredInstallmentsBalance.totalToPay)"-->
      <!--       [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">-->
      <!--    {{ getPercent(filteredInstallmentsBalance.totalPaid, filteredInstallmentsBalance.totalToPay) }}%-->
      <!--  </div>-->
      <!--</div>-->
    </div>
    <div *ngIf="componentType === 'admin'" class="col" style="min-width: 500px">
      <div class="row">

        <div class="col" *ngIf="isPhaseTwo(); else lsoviewbalance">
          <span>Plan balance:</span>
          <span class="font-weight-bold">
            {{ (debtPlanInstallmentsBalance.totalToPay - debtPlanInstallmentsBalance.totalPaid) | number: '1.2-2' }} €
          </span>
        </div>

        <ng-template #lsoviewbalance>
          <div class="col" *ngIf="case.product.slug !== 'ds' && case.product.slug !== 'refinance'">
            <span>{{ 'CASES.single.payments.balance_overview.debt_plan_balance' |translate }}:</span>
            <span class="font-weight-bold">
              {{ (debtPlanInstallmentsBalance.totalToPay - debtPlanInstallmentsBalance.totalPaid) | number: '1.2-2' }} €
            </span>
          </div>
        </ng-template>

        <div class="col" *ngIf="isPhaseTwo(); else lsoviewpbalance">
          <div class="progress total-progress" style="max-width: 300px">
            <div class="progress-bar progress-bar-striped" role="progressbar"
                 [style]="{width: getPercent((debtPlanInstallmentsBalance.totalPaid),templateData[0].DMTotalDebtAmount) + '%'}"
                 [attr.aria-valuenow]="getPercent((debtPlanInstallmentsBalance.totalPaid),templateData[0].DMTotalDebtAmount)"
                 [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
              {{
                getPercent(
                  (debtPlanInstallmentsBalance.totalPaid),
                  templateData[0].DMTotalDebtAmount
                )
              }}%
            </div>
          </div>
        </div>

        <ng-template #lsoviewpbalance>
          <div class="col" *ngIf="case.product.slug !== 'ds' && case.product.slug !== 'refinance'">
            <div class="progress total-progress" style="max-width: 300px">
              <div class="progress-bar progress-bar-striped" role="progressbar"
                   [style]="{width: getPercent(debtPlanInstallmentsBalance.totalPaid, debtPlanInstallmentsBalance.totalToPay) + '%'}"
                   [attr.aria-valuenow]="getPercent(debtPlanInstallmentsBalance.totalPaid, debtPlanInstallmentsBalance.totalToPay)"
                   [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
                {{ getPercent(debtPlanInstallmentsBalance.totalPaid, debtPlanInstallmentsBalance.totalToPay) }}%
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="row mt-2">

        <div class="col" *ngIf="isPhaseTwo(); else lsoadditionaplansbalance">
          <span>unifye fees:</span>
          <span class="font-weight-bold">
            {{ case.expense.distribution_fee * templateData[0].DMMonthsFeeFullyPaid + ' €' }}
          </span>
        </div>

        <ng-template #lsoadditionaplansbalance>
          <div class="col" *ngIf="case.product.slug !== 'ds' && case.product.slug !== 'refinance'">
            <span>{{ 'CASES.single.payments.balance_overview.additional_plans_balance' | translate }}:</span>
            <span class="font-weight-bold">
             {{
                (additionalPlansInstallmentsBalance.totalToPay -
                  additionalPlansInstallmentsBalance.totalPaid) | number: '1.2-2'
              }} €
            </span>
          </div>
        </ng-template>

        <div class="col" *ngIf="isPhaseTwo(); else lsoadditionaplansbalancepbar">
          <div class="progress total-progress" style="max-width: 300px">
            <div class="progress-bar progress-bar-striped" role="progressbar"
                 [style]="{width: getPercent(case.expense.distribution_fee*templateData[0].DMMonthsFeeFullyPaid,case.expense.distribution_fee*case.terms.length) + '%'}"
                 [attr.aria-valuenow]="getPercent(case.expense.distribution_fee*templateData[0].DMMonthsFeeFullyPaid,case.expense.distribution_fee*case.terms.length)"
                 [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
              {{
                getPercent(
                  case.expense.distribution_fee * templateData[0].DMMonthsFeeFullyPaid,
                  case.expense.distribution_fee * case.terms.length
                )
              }}%
            </div>
          </div>
        </div>

        <ng-template #lsoadditionaplansbalancepbar>
          <div class="col" *ngIf="case.product.slug !== 'ds' && case.product.slug !== 'refinance'">
            <div class="progress total-progress" style="max-width: 300px">
              <div class="progress-bar progress-bar-striped" role="progressbar"
                   [style]="{width: getPercent(additionalPlansInstallmentsBalance.totalPaid, additionalPlansInstallmentsBalance.totalToPay) + '%'}"
                   [attr.aria-valuenow]="getPercent(additionalPlansInstallmentsBalance.totalPaid, additionalPlansInstallmentsBalance.totalToPay)"
                   [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
                {{
                  getPercent(
                    additionalPlansInstallmentsBalance.totalPaid,
                    additionalPlansInstallmentsBalance.totalToPay
                  )
                }}%
              </div>
            </div>
          </div>
        </ng-template>
      </div>
      <div class="row mt-2">

        <div class="col" *ngIf="isPhaseTwo(); else lsooverviewtotalbalance">
          <span>months remaining:</span>
          <span class="font-weight-bold">
          {{ templateData[0].DmTotalMonthsPending }} / {{ case.terms.length }}
        </span>
        </div>

        <ng-template #lsooverviewtotalbalance>
          <div class="col">
            <span>{{ 'CASES.single.payments.balance_overview.total_balance' | translate }}:</span>
            <span class="font-weight-bold">
            {{
                ((debtPlanInstallmentsBalance.totalToPay + additionalPlansInstallmentsBalance.totalToPay) -
                  (debtPlanInstallmentsBalance.totalPaid +
                    additionalPlansInstallmentsBalance.totalPaid)) | number: '1.2-2'
              }} €
          </span>
          </div>
        </ng-template>


        <div class="col" *ngIf="isPhaseTwo(); else lsooverviewtotalbalancepbar">
          <div class="progress total-progress" style="max-width: 300px">
            <div class="progress-bar progress-bar-striped" role="progressbar"
                 [style]="{width: getPercent(templateData[0].DMMonthsFeeFullyPaid,case.terms.length) + '%'}"
                 [attr.aria-valuenow]="getPercent(templateData[0].DMMonthsFeeFullyPaid,case.terms.length)"
                 [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
              {{
                getPercent(
                  templateData[0].DMMonthsFeeFullyPaid,
                  case.terms.length)
              }} %
            </div>
          </div>
        </div>

        <ng-template #lsooverviewtotalbalancepbar>
          <div class="col">
            <div class="progress total-progress" style="max-width: 300px">
              <div class="progress-bar progress-bar-striped" role="progressbar"
                   [style]="{width: getPercent(debtPlanInstallmentsBalance.totalPaid +
              additionalPlansInstallmentsBalance.totalPaid, debtPlanInstallmentsBalance.totalToPay +
              additionalPlansInstallmentsBalance.totalToPay) + '%'}"
                   [attr.aria-valuenow]="getPercent(debtPlanInstallmentsBalance.totalPaid +
              additionalPlansInstallmentsBalance.totalPaid, debtPlanInstallmentsBalance.totalToPay +
              additionalPlansInstallmentsBalance.totalToPay)"
                   [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
                {{
                  getPercent(debtPlanInstallmentsBalance.totalPaid +
                    additionalPlansInstallmentsBalance.totalPaid, debtPlanInstallmentsBalance.totalToPay +
                    additionalPlansInstallmentsBalance.totalToPay)
                }}%
              </div>
            </div>
          </div>
        </ng-template>

      </div>
      <!--<div class="row" *ngIf="case.product.slug === 'ds' || case.product.slug === 'refinance'">-->
      <!--  <div class="col">-->
      <!--    Non settlement balance-->
      <!--  </div>-->
      <!--  <div class="col">-->

      <!--  </div>-->
      <!--</div>-->
      <!-- Settlement balance-->
      <div class="row mt-2" *ngIf="case.product.slug === 'ds'">
        <div class="col">
          {{'CASES.single.payments.settlement_balance' | translate}}: <span class="font-weight-bold ">{{ settlementBalance | currency }}</span>
        </div>
        <div class="col">
          <div class="progress total-progress" style="max-width: 300px">
            <div class="progress-bar progress-bar-striped" role="progressbar"
                 [style]="{width: getPercent(totalAmountPaidDebtPlan +
              totalAmountPaidDebtPlan, +case?.settlement_paid +
              +case?.settlement_paid) + '%'}"
                 [attr.aria-valuenow]="getPercent(totalAmountPaidDebtPlan +
              totalAmountPaidDebtPlan, +case?.settlement_paid +
              +case?.settlement_paid)"
                 [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
              {{
                getPercent(totalAmountPaidDebtPlan +
                  totalAmountPaidDebtPlan, +case?.settlement_paid +
                  +case?.settlement_paid)
              }}%
            </div>
          </div>
        </div>
      </div>
      <!-- Management balance-->
      <div class="row mt-2" *ngIf="case.product.slug === 'ds'">
        <div class="col">
          {{'CASES.single.payments.management_balance' | translate}}: <span class="font-weight-bold ">{{ managementBalance | currency }}</span>
        </div>
        <div class="col">
          <div class="progress total-progress" style="max-width: 300px">
            <div class="progress-bar progress-bar-striped" role="progressbar"
                 [style]="{width: getPercent(totalAmountPaidManagement +
              totalAmountPaidManagement, +case?.settlement_paid +
              +case?.settlement_paid) + '%'}"
                 [attr.aria-valuenow]="getPercent(totalAmountPaidManagement +
              totalAmountPaidManagement, +totalDebtAmountManagement +
              +totalDebtAmountManagement)"
                 [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
              {{
                getPercent(totalAmountPaidManagement +
                  totalAmountPaidManagement, +totalDebtAmountManagement +
                  +totalDebtAmountManagement)
              }}%
            </div>
          </div>
        </div>
      </div>
      <!-- Negotiation balance-->
      <div class="row my-2" *ngIf="case.product.slug === 'ds' || case.product.slug === 'refinance'">
        <div class="col">
          {{'CASES.single.payments.negotiation_balance' | translate}}: <span class="font-weight-bold ">{{ negotiationBalance | currency }}</span>
        </div>
        <div class="col">
          <div class="progress total-progress" style="max-width: 300px">
            <div class="progress-bar progress-bar-striped" role="progressbar"
                 [style]="{width: getPercent(totalAmountPaidNegotiation +
              totalAmountPaidNegotiation, +totalDebtAmountNegotiation +
              +totalDebtAmountNegotiation) + '%'}"
                 [attr.aria-valuenow]="getPercent(totalAmountPaidNegotiation +
              totalAmountPaidNegotiation, +totalDebtAmountNegotiation +
              +totalDebtAmountNegotiation)"
                 [attr.aria-valuemin]="0" [attr.aria-valuemax]="100">
              {{
                getPercent(totalAmountPaidNegotiation +
                  totalAmountPaidNegotiation, +totalDebtAmountNegotiation +
                  +totalDebtAmountNegotiation)
              }}%
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="text-right payment-action-buttons">
    <div *ngIf="componentType === 'admin'" class="admin-payment-actions">
      <button (click)="openPaymentPlanGenerationModal()" mat-raised-button color="primary"
              class="mr-2" [disabled]="!isElementRestricted()">
        {{ 'CASES.single.payments.actions.create_additional_payment_plan' | translate }}
      </button>
      <!-- <div class="form-group d-inline-block mr-2">
        <select name="payment_method" id="payment-method" class="form-control custom-disabled-button"
              (change)="changePaymentMethod($event)" [disabled]="!isElementRestricted()">
          <option *ngFor="let method of paymentMethods" value="{{method.slug}}"
                  style="font-family: 'Roboto', 'Helvetica', 'Neue', 'sans-serif'"
                  [selected]="paymentMethodIsSelected(method.id)">{{ method.name }}</option>
        </select>
      </div> -->
      <ng-container *ngIf="upcomingInstallments">
        <button [matMenuTriggerFor]="requestPaymentMenu" mat-raised-button class="mr-2" color="primary"
                [disabled]="!upcomingInstallments || upcomingInstallments?.length === 0 ||
             (installmentsPlanTypeSlugsControl.value.length > 1 && installmentsPlanTypeSlugsControl.value.includes('debt_plan'))">
          {{ "CASES.single.payments.actions.request_payment.label" | translate }}
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #requestPaymentMenu="matMenu">
          <button mat-menu-item (click)="requestPaymentDialog('card', 'oppwa')">
            <span>{{ "CASES.single.payments.actions.request_payment.options.oppwa" | translate }}</span>
          </button>
          <!--      <button mat-menu-item *ngIf="appEnv === 'local' || appEnv === 'staging' ||-->
          <!--       (authUser.role_id === 5 && allowedMymoidIds.includes(authUser.id))"-->
          <!--              (click)="requestPaymentDialog('card', 'mymoid')">-->
          <!--        <span>{{ "CASES.single.payments.actions.request_payment.options.mymoid" | translate }}</span>-->
          <!--      </button>-->
        </mat-menu>
      </ng-container>
      <button (click)="rebuildInstallmentPlanModal()" mat-raised-button color="primary"
              class="mr-2" [disabled]="!onlyDebtPlanSelected || !isElementRestricted()">
        {{ "CASES.single.rebuild-plan" | translate }}
      </button>
      <button *ngIf="upcomingInstallments" (click)="openDialog(false)" mat-raised-button color="primary"
              class="mr-2" [disabled]="upcomingInstallments?.length === 0 ||
         (installmentsPlanTypeSlugsControl.value.length > 1 && installmentsPlanTypeSlugsControl.value.includes('debt_plan'))
         || !isElementRestricted()">
        {{ "CASES.single.record-payment" | translate }}
      </button>
      <button *ngIf="upcomingInstallments" (click)="openDialog(true)" mat-raised-button color="primary"
              class="mr-2" [disabled]="upcomingInstallments?.length === 0 ||
         (installmentsPlanTypeSlugsControl.value.length > 1 && installmentsPlanTypeSlugsControl.value.includes('debt_plan'))
         || !isElementRestricted()">
        {{ "CASES.single.relocate-payment" | translate }}
      </button>
      <div class="d-inline-block" matTooltip="No upcoming payment available"
           [matTooltipDisabled]="case.terms.length > 0">
        <button *ngIf="upcomingInstallments" [disabled]="upcomingInstallments?.length === 0 ||
         (installmentsPlanTypeSlugsControl.value.length > 1 && installmentsPlanTypeSlugsControl.value.includes('debt_plan')) || case.locked_no_products == true"
                (click)="openCardModal()" mat-raised-button color="primary">
          {{ "CASES.single.take-payment" | translate }}
        </button>
      </div>
      <!-- <button [matMenuTriggerFor]="remittanceRequestMenu" mat-raised-button color="primary"
          class="ml-2" [disabled]="!isElementRestricted()">
        {{ "CASES.single.remittance-request-text" | translate }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #remittanceRequestMenu>
        <button mat-menu-item (click)="generateRemittanceRequest()"><span>{{"SHARED.generate" | translate}}</span>
        </button>
      </mat-menu> -->
      <button [matMenuTriggerFor]="clientInstallmentMenu" mat-raised-button color="primary"
              class="ml-2" [disabled]="!isElementRestricted()">
        {{ 'CASES.single.client-installment-list-btn' | translate }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #clientInstallmentMenu>
        <button mat-menu-item (click)="downloadClientInstallment()">
          <span>{{ 'CASES.single.download' | translate }}</span>
        </button>
        <a mat-menu-item [routerLink]="['/cases', case?.id, 'payments', case.uuid, 'preview-client-installment-list']"
           target="_blank">
          <span>{{ 'CASES.single.client-installment-list-preview' | translate }}</span></a>
        <button mat-menu-item (click)="sendPaymentPlan()">
          <span>{{ 'CASES.single.client-installment-list-send' | translate }}</span></button>
      </mat-menu>
      <div class="d-inline-block ml-2">
        <button (click)="transferFeesModal()" mat-raised-button color="primary"
                [disabled]="!allowedFundsTransfer.includes(authUser.id)">
          Transfer Fees
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="authUser?.id === 1 || isLocalOrStagingEnvironment" class="row">
  <div class="col d-flex flex-row justify-content-end text-right">
    <div>
      <p>sum_total_debt_amount: {{ case.sum_total_debt_amount | number:'1.2-2' }}</p>
      <p>sum_total_negotiated_amount: {{ case.sum_total_negotiated_amount | number:'1.2-2' }}</p>
      <p>sum_total_reduction: {{ case.sum_total_reduction | number:'1.2-2' }}</p>
      <p>debt_reduction: {{ case.debt_reduction | number:'1.2-2' }}</p>
      <p>Is above 50%: {{ case?.is_above50_percent }}</p>
    </div>
    <div class="ml-3">
      <p>microlenders: {{ case.microlenders }}</p>
      <p>settlement_paid: {{ case.settlement_paid | number:'1.2-2' }}</p>
      <p>settlement_fees: {{ case.settlement_fees | number:'1.2-2' }}</p>
      <p>settlement_received: {{ case.settlement_received | number:'1.2-2' }}</p>
      <p>settlement_balance: {{ case.settlement_balance | number:'1.2-2' }}</p>
    </div>
  </div>
</div>

<mat-tab-group (selectedTabChange)="tabChanged($event)">
  <mat-tab [label]="'CASES.single.payments.heading' | translate">
    <app-upcoming-installment-list *ngIf="case && installmentListActive" [case]="case"
                               [openRecordPaymentDialog]="openRecordPaymentDialog"
                               (selectionChanged)="selectionPaymentsDisabledChanged($event)"
                               (paymentRecorded)="paymentRecorded"
                               (installmentPlanTypeGroupChanged)="installmentPlanTypeGroupChanged($event)"
                               [componentType]="componentType">
    </app-upcoming-installment-list>
  </mat-tab>
  <mat-tab *ngIf="case.product.slug === 'ds' || case.product.slug === 'refinance'"
           [label]="'CASES.single.payments.setup_fee' | translate">
    <app-case-installment-fees *ngIf="case" [componentType]="componentType" [case]="case" [feeType]="'setup_fee'">
    </app-case-installment-fees>
  </mat-tab>
  <mat-tab *ngIf="case.product.slug === 'ds'"
           [label]="'CASES.single.payments.management_fee' | translate">
    <app-case-installment-fees *ngIf="case" [componentType]="componentType" [case]="case" [feeType]="'management_fee'">
    </app-case-installment-fees>
  </mat-tab>
  <mat-tab *ngIf="case.product.slug === 'ds' || case.product.slug === 'refinance'"
           [label]="'CASES.single.payments.negotiation_fee' | translate">
    <app-case-installment-fees *ngIf="case" [componentType]="componentType" [case]="case" [feeType]="'negotiation_fee'">
    </app-case-installment-fees>
  </mat-tab>
  <mat-tab [label]="'CASES.single.payments.debt_plan_fee' | translate">
    <app-case-installment-fees *ngIf="case" [componentType]="componentType" [case]="case" [feeType]="'debt_plan_fee'">
    </app-case-installment-fees>
  </mat-tab>
</mat-tab-group>

